var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-caret-down 1",
    clipPath: "url(#clip0_3565_8679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0.5C4.81331 0.5 3.65328 0.851894 2.66658 1.51118C1.67989 2.17047 0.910851 3.10754 0.456726 4.2039C0.00259972 5.30026 -0.11622 6.50666 0.115291 7.67054C0.346802 8.83443 0.918247 9.90353 1.75736 10.7426C2.59648 11.5818 3.66558 12.1532 4.82946 12.3847C5.99335 12.6162 7.19975 12.4974 8.2961 12.0433C9.39246 11.5892 10.3295 10.8201 10.9888 9.83342C11.6481 8.84673 12 7.68669 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5ZM8.7 5.9L6.2 9.233C6.17684 9.26423 6.14669 9.2896 6.11196 9.30709C6.07723 9.32457 6.03889 9.33367 6 9.33367C5.96112 9.33367 5.92278 9.32457 5.88805 9.30709C5.85332 9.2896 5.82316 9.26423 5.8 9.233L3.3 5.9C3.27215 5.86286 3.25518 5.81869 3.25101 5.77245C3.24684 5.72621 3.25563 5.67972 3.2764 5.6382C3.29716 5.59667 3.32908 5.56175 3.36857 5.53734C3.40806 5.51293 3.45357 5.5 3.5 5.5H8.5C8.54643 5.5 8.59194 5.51293 8.63144 5.53734C8.67093 5.56175 8.70285 5.59667 8.72361 5.6382C8.74437 5.67972 8.75316 5.72621 8.74899 5.77245C8.74482 5.81869 8.72786 5.86286 8.7 5.9Z",
    fill: "#3DA64F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_8679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/successCircle.6d67bfeac3654b4c30bf22792c1683f4.svg";
export { ForwardRef as ReactComponent };